import {
  descomplicaURL,
  dexWebURL,
  dexExamsURL,
} from '@/dex-shared/settings/endpoints';

export default {
  courseUrl: (_state: any, getters: any) => {
    if (getters.userLastCourse) {
      return `${descomplicaURL}/cursos/${getters.userLastCourse.slug}`;
    } else {
      return descomplicaURL;
    }
  },
  disciplinesUrl: (_state: any, getters: any) => `${getters.courseUrl}/busca`,
  studyPlanUrl: (_state: any, getters: any) => {
    if (getters.userLastCourse) {
      return `${getters.courseUrl}/planejamentos/${getters.userLastCourse.currentWeekPlanning.serial}`;
    } else {
      return descomplicaURL;
    }
  },
  liveUrl: (_state: any, getters: any) => `${getters.studyPlanUrl}/ao-vivo`,
  tutoringUrl: (_state: any, getters: any) =>
    `${getters.studyPlanUrl}/monitorias`,
  essaysUrl: (_state: any, getters: any) => {
    if (getters.courseUrl === descomplicaURL) return getters.courseUrl;

    return `${getters.courseUrl}/redacao`;
  },
  homeUrl: (_state: any, getters: any) => {
    if (getters.userLastCourse) {
      return `${getters.courseUrl}/inicio`;
    }

    return descomplicaURL;
  },
  descomplicaLinks: (_state: any, getters: any) => [
    {
      text: 'Página Inicial',
      url: getters.homeUrl,
    },
    {
      text: 'Plano de Estudos',
      url: getters.studyPlanUrl,
    },
    {
      text: 'Ao Vivo',
      url: getters.liveUrl,
    },
    {
      text: 'Monitoria',
      url: getters.tutoringUrl,
    },
    {
      text: 'Exercícios',
      url: dexWebURL,
    },
    {
      text: 'Redação',
      url: window.location.origin,
    },
    {
      text: 'Simulados',
      url: dexExamsURL,
    },
    {
      text: 'Disciplinas',
      url: getters.disciplinesUrl,
    },
  ],
};
